import React, { useEffect, useRef } from 'react';
import Globals from '../contexts/Globals';
import I18nLib from '../lib/I18nLib';
import BlackoutAPI from '../lib/BlackoutAPI';
import { logError } from '../lib/Debug';

function XsollaUserIdManager({ clubs, onClubsUpdated, showDropdown = false, showIndividualIds = false, isXsollaAvailable = false }) {
	let globals = Globals.useContainer();
	let i18n = I18nLib.init(globals);
	
	const clubsRef = useRef(clubs);
	const onClubsUpdatedRef = useRef(onClubsUpdated);
	const tokenRef = useRef(globals.userState.token?.accessToken);
	const loadedClubsRef = useRef(new Set()); // Track which clubs we've already loaded IDs for

	useEffect(() => {
		clubsRef.current = clubs;
		onClubsUpdatedRef.current = onClubsUpdated;
		tokenRef.current = globals.userState.token?.accessToken;
	}, [clubs, onClubsUpdated, globals.userState.token]);

	const updateClubsWithXsollaId = React.useCallback((id, xsollaUserId) => {
		if (onClubsUpdatedRef.current) {
			onClubsUpdatedRef.current(items =>
				items.map(item => 
					item.id === id ? { ...item, ...xsollaUserId } : item
				)
			);
		}
	}, []);

	const loadedCountRef = useRef(0);

	const getXsollaIdForClubs = React.useCallback((clubs) => {
		if (!tokenRef.current) return;
		
		let headers = {
			'token': tokenRef.current
		};

		let clubsToLoad = 0;
		loadedCountRef.current = 0;

		for (let i = 0; i < clubs.length; i++) {
			if (clubs[i] && clubs[i].id && !loadedClubsRef.current.has(clubs[i].id)) {
				clubsToLoad++;
				
				const clubId = clubs[i].id;
				const currentClubsToLoad = clubsToLoad;
				
				BlackoutAPI.get({
					endpoint: 'xsolla-webstore',
					id: clubId,
					headers
				}).then(res => {
					let clubData = res.data.clubData;
					updateClubsWithXsollaId(clubId, { xsollaUserId: clubData[0].xsollaUserId });
					loadedClubsRef.current.add(clubId); // Mark as loaded
					loadedCountRef.current++;
					
					if (loadedCountRef.current === currentClubsToLoad) {
						// All requested clubs have been processed
					}
				}).catch(err => {
					logError('Failed to load Xsolla ID for club:', err);
					loadedClubsRef.current.add(clubId); 
					loadedCountRef.current++;
					
					if (loadedCountRef.current === currentClubsToLoad) {
						// All requested clubs have been processed
					}
				});
			}
		}
	}, [updateClubsWithXsollaId]); 

	useEffect(() => {
		if (clubs && clubs.length && tokenRef.current) {
			getXsollaIdForClubs(clubs);
		}
	}, [clubs, getXsollaIdForClubs]); 

	return (
		<div className="xsolla-user-id-manager gap-after">
			{isXsollaAvailable && showDropdown && (
				<div className='xsolla-user-id-container'>
					<div className="xsolla-id-title gold-text">{i18n('account.xsolla-description', 'Did you know you can get cheaper prices on our web store? To get started, click "Go to Webstore" on a club below.')}</div>
				</div>
			)}
		</div>
	);
}

export default XsollaUserIdManager; 